import React from 'react';
import { useTranslation } from 'react-i18next';
import StatLayout from '../StatLayout';
import PremiumIcon from '../../../Icons/Premium';
export var OwnerPcpStat = function (_a) {
    var editUrl = _a.editUrl;
    var t = useTranslation().t;
    return (React.createElement(StatLayout, { icon: PremiumIcon, tooltip: {
            tooltipKey: t('actionbar.pcp.owned'),
        }, link: {
            href: editUrl,
            target: '_top',
            isDownload: false,
        } }));
};
OwnerPcpStat.displayName = 'OwnerPcpStat';
export default OwnerPcpStat;
//# sourceMappingURL=OwnerPcpStat.js.map